import Bus from '@/bus'

import ApiMixin from '@/mixins/api'

export default {
  mixins: [ApiMixin],

  methods: {
    async cancelAllPendingTransactions (transactions) {
      try {
        // pull up all active transactions and void each
        Bus.$emit('openWaitModal')

        let responses = []
        let hasError = false

        for (let transaction of this.transactions) {
          // if (transaction.response_code !== '000' || transaction.voided || transaction.settled) {
          //   console.log('skip')
          //   continue
          // }

          if (transaction.request_type !== 'sale' && transaction.request_type !== 'credit' && transaction.request_type !== 'ach' && transaction.request_type !== 'achcredit') {
            continue
          }

          if (transaction.response_code === '000' && !transaction.voided && !transaction.settled) {
            let options = {
              terminal_id: transaction.terminal_id,
              transaction_id: transaction.id
            }

            let result = await this.api({
              method: 'post',
              url: `/terminal/void`,
              data: options
            })

            if (result.data) {
              if (result.data.response.ActionCode === '000') {
                responses.push({
                  id: transaction.id,
                  custom_tracking_id: transaction.custom_tracking_id,
                  status: 'success'
                })
              } else {
                hasError = true
                responses.push({
                  id: transaction.id,
                  custom_tracking_id: transaction.custom_tracking_id,
                  status: 'error',
                  message: result.data.response.ResponseText,
                  error: result.data.response.ErrMsg || ''
                })
              }
            } else {
              hasError = true
              responses.push({
                id: transaction.id,
                custom_tracking_id: transaction.custom_tracking_id,
                status: 'error',
                message: 'unknown',
                error: 'unknown'
              })
            }
          } else if (transaction.is_recurring && (transaction.settled || transaction.ach_rejected) && !transaction.parent_transaction_id && transaction.modify_recurring_type !== 'none' && transaction.recurring_type !== 'none') {
            // if current recurring, modify and cancel
            // @TODO if ach, could not be settled or have an error code?

            let options = {
              account_id: transaction.account_id,
              terminal_id: transaction.terminal_id,
              token_id: transaction.token_id,
              unique_id: transaction.tracking_id,
              transaction_group_id: this.transaction.transaction_group_custom_tracking_id,
              is_recurring: true,
              is_installment: 1,
              recurring_type: 'none',
              recurring_offset: new Date().getTimezoneOffset() / 60,
              recurring_start_date: (transaction.modify_recurring_start ? transaction.modify_recurring_start : transaction.recurring_start),
              recurring_end_date: (transaction.modify_recurring_end ? transaction.modify_recurring_end : transaction.recurring_end),
              total_amount: ((transaction.modify_total_amount ? transaction.modify_total_amount : transaction.total_amount) - (transaction.modify_fee_amount ? transaction.modify_fee_amount : transaction.fee_amount)) / 100, // required for FAPS
              waive_fee: transaction.is_fee_waived,
              fee_amount: transaction.is_fee_waived ? 0 : ((transaction.modify_fee_amount ? transaction.modify_fee_amount : transaction.fee_amount) / 100), // required for modify endpoint to properly calculate
              fee_waived: transaction.is_fee_waived ? ((transaction.modify_fee_amount ? transaction.modify_fee_amount : transaction.fee_amount) / 100) : 0
            }

            let result = await this.api({
              method: 'post',
              url: `/terminal/modify`,
              data: options
            })

            if (result.data) {
              if (result.data.response.ResponseText === 'MODIFY ACCEPTED') {
                responses.push({
                  id: transaction.id,
                  custom_tracking_id: transaction.custom_tracking_id,
                  status: 'success'
                })
              } else {
                hasError = true
                responses.push({
                  id: transaction.id,
                  custom_tracking_id: transaction.custom_tracking_id,
                  status: 'error',
                  message: result.data.response.ResponseText,
                  error: result.data.response.ErrMsg || ''
                })
              }
            } else {
              hasError = true
              responses.push({
                id: transaction.id,
                custom_tracking_id: transaction.custom_tracking_id,
                status: 'error',
                message: 'unknown',
                error: 'unknown'
              })
            }
          }
        }

        if (!responses.length) {
          Bus.$emit('openModal', {status: 'info', message: 'Nothing to process'})
        } else if (hasError) {
          Bus.$emit('openModal', {status: 'error', message: responses})
        } else {
          Bus.$emit('openModal', {status: 'success', message: 'All installments have been cancelled'})
          this.load()
        }
      } catch (error) {
        Bus.$emit('openModal', {status: 'error', message: error})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/plans.js